module.exports = __webpack_public_path__ + "assets/img/c34.996836fd.png";